export default __webpack_public_path__ + "static/media/instgramsvg.b9bcfc87.svg";